import { FileReader, FileWriter } from '@/platform'
class GoodPropertyModel {
    public PropertyId: number = -1 // 属性ID
    public Operation: number = -1 // 操作符
    public Number: number = -1 // 数值

    readVersionedOui(reader: FileReader): void {
        this.PropertyId = reader.readInt()
        this.Operation = reader.readInt()
        this.Number = reader.readInt()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.PropertyId)
        writer.writeInt(this.Operation)
        writer.writeInt(this.Number)

        writer.writerLength()
    }

    writeMallBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}
export default GoodPropertyModel
